import { useEffect, useState } from "react";
import type { FC } from "react";
import { useLocation, matchPath } from "react-router-dom";

import { Box, Divider, Drawer, IconButton, List } from "@material-ui/core";

import { Scrollbar } from "../../components/atoms/Scrollbar";
import { SidebarItem } from "../molecules/Sidebar/SidebarItem";
import { Logo } from "../../components/atoms/Logo";

import { ChevronLeft as ChevronLeftIcon } from "../../icons/chevron-left";
import { ChevronRight as ChevronRightIcon } from "../../icons/chevron-right";

import { Route } from "src/types/interfaces/Route";
import { routes } from "src/constans/routes";
import { SidebarItemsGroup } from "../molecules/Sidebar/SidebarItemsGroup";


interface SidebarProps {
  onPin: () => void;
  pinned: boolean;
}

export const Sidebar: FC<SidebarProps> = (props) => {
  const { onPin, pinned } = props;
  const { pathname } = useLocation();
  const [openedRoute, setOpenedRoute] = useState<Route | null>(null);
  const [activeRoute, setActiveRoute] = useState<Route | null>(null);
  const [activeHref, setActiveHref] = useState("");
  const [hovered, setHovered] = useState(false);


  const handleToggleRoute = (route: Route): void => {
    if (openedRoute === route) {
      setOpenedRoute(null);

      return;
    }

    setOpenedRoute(route);
  };

  useEffect(() => {
    routes.forEach((route) => {
      if (route.subRoutes) {
        for (let index = 0; index < route.subRoutes.length; index++) {
          const active = matchPath({ path: route.subRoutes[index].href, end: true }, pathname);

          if (active) {
            setActiveRoute(route);
            setActiveHref(route.subRoutes[index].href);
            setOpenedRoute(route);
            break;
          }
        }
      } else {
        const active = matchPath({ path: route.href, end: true }, pathname);

        if (active) {
          setActiveRoute(route);
        }
      }
    });
  }, [pathname]);

  return (
    <Drawer
      open
      // sx={{ zIndex: 1000 }}
      variant="permanent"
      PaperProps={{
        onMouseOver: () => {
          setHovered(true);
        },
        onMouseLeave: () => {
          setHovered(false);
        },
        sx: {
          backgroundColor: "background.paper",
          height: "calc(100% - 64px)",
          overflowX: "hidden",
          top: 64,
          zIndex: 1,
          transition: "width 250ms ease-in-out",
          width: pinned ? 270 : 73,
          "& .simplebar-content": {
            height: "100%",
          },
          "&:hover": {
            width: 270,
            "& span, p": {
              display: "flex",
            },
          },
        },
      }}
    >
      <Scrollbar
        style={{
          display: "flex",
          flex: 1,
          overflowX: "hidden",
          overflowY: "auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            p: 2,
          }}
        >
          <List disablePadding>
            {routes.map((route) =>
              route.subRoutes ? (
                <SidebarItemsGroup
                  key={route.title}
                  onClick={() => handleToggleRoute(route)}
                  open={openedRoute?.title === route.title && (hovered || pinned)}
                  active={activeRoute?.title === route.title}
                  activeHref={activeHref}
                  pinned={pinned}
                  icon={route.icon}
                  subRoutes={route.subRoutes}
                  title={route.title}
                />
              ) : (
                <SidebarItem
                  key={route.title}
                  href={route.href}
                  active={activeRoute?.title === route.title}
                  external={route.external}
                  title={route.title}
                  pinned={pinned}
                  {...route}
                />
              )
            )}
          </List>
          <Box sx={{ flexGrow: 1 }} />
          <Divider />
          <Box
            sx={{
              pt: 1,
              mr: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <IconButton onClick={onPin}>
              {pinned ? <ChevronLeftIcon /> : <ChevronRightIcon />}
            </IconButton>
            <Logo height={17} width={70} />
          </Box>
        </Box>
      </Scrollbar>
    </Drawer>
  );
};
